import classNames from 'classnames/bind';
import React, { memo } from 'react';
import { Link } from "../Link";
import style from "./style.pcss";
import { storeVariants } from "./types";
var cn = classNames.bind(style);
export var MobileAppButton = /*#__PURE__*/memo(function (_ref) {
  var _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return false;
    } : _ref$onClick,
    variant = _ref.variant,
    isFullWidth = _ref.isFullWidth,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'black' : _ref$backgroundColor,
    href = _ref.href,
    target = _ref.target,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'MobileAppButton' : _ref$testName;
  var MobileAppIcon = storeVariants[variant];
  return /*#__PURE__*/React.createElement(Link, {
    className: cn('mobile-app-button', "mobile-app-button--".concat(backgroundColor), {
      'mobile-app-button--with-full-width': isFullWidth,
      'mobile-app-button--googlePlay': variant === 'googlePlay'
    }),
    "data-component": testName,
    href: href,
    onClick: onClick,
    target: target,
    "data-t-id": "src-MobileAppButton"
  }, /*#__PURE__*/React.createElement(MobileAppIcon, {
    fill: backgroundColor === 'white' ? 'black' : 'white',
    size: 32,
    "data-t-id": "src-MobileAppButton"
  }));
});
MobileAppButton.displayName = MobileAppButton.name;